<div class="legal-container" [attr.data-e2e]="'info:legal-notice'">
  <h4 i18n="@@headline.legal_notice">Hinweise</h4>
  <ul class="list-force">
    <li
      *ngFor="let note of legalNotes$ | async; trackBy: trackByIndex"
      [innerHTML]="note"
    ></li>
  </ul>
</div>
